import { addressService } from '@/api'

const state = {
  list: [],
  selected: 0, // 已选择的地址ID
  item: {
    // id: '5',
    // contactName: '张三',
    // areaCode: '86', // 地区码
    // contactNo: '13126666666',
    // addressArea: '北京市 / 北京市 / 东城区',
    // addressDetail: '海龙大厦1426',
    // defaultMark: 1
  }
}

const getters = {
  addressList: state => state.list, // 地址列表
  address: state => state.item // 默认地址或编辑中
}

const mutations = {
  setList: (state, list) => {
    state.list = list.map(item => mergeAreaDetail(item))
  },
  // 订单页：设置默认地址
  setDefault: (state, item) => {
    state.item = mergeAreaDetail(item || {})
  },
  // 地址编辑：获取地址
  getItemById: (state, { id, isselect }) => {
    let item = null
    if (id > 0) {
      if (isselect) state.selected = id
      item = state.list.find(a => a.id === id)
    }
    if (item == null) {
      item = {} // 添加时，或编辑无数据
    }
    state.item = mergeAreaDetail(item || {})
  }
}

const actions = {
  // 获取列表
  async getList({ commit }) {
    const list = await addressService.list()
    commit('setList', list)
    return list
  },
  // 订单页：设置默认地址
  async getDefault({ commit }) {
    const item = await addressService.list('default')
    commit('setDefault', item)
    return item
  },
  // 地址编辑：获取地址 | 选择地址并设为默认地址
  async getItem({ commit, state }, query) {
    if (query.isselect) {
      await addressService.mark(query)
    }
    commit('getItemById', query)
    return state.item
  },
  // 添加
  async addItem({ commit }, item) {
    await addressService.save(item)
    commit('setItem', item)
  },
  // 更新
  async setItem({ commit, state }, item) {
    if (!item) return
    await addressService.save(item)
    state.list[state.list.findIndex(ite => ite.id === item.id)] = item
    commit('getItemById', item) // 同步项
  },
  // 删除
  async removeItem({ commit }, item) {
    if (!item.id) return
    await addressService.del(item)
    commit('setDefault', {}) // 同步项
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

/**
 * 合并地址和详情为显示的地址内容
 * @param {*} item
 */
function mergeAreaDetail(item) {
  let { addressArea: area, addressDetail: detail } = item
  area = area || ''
  detail = detail || ''
  const areaArr = area.split(' / ') // 省市区分隔符
  const [p, c, a] = areaArr
  area = areaArr.length > 1 ? (p === c ? p : p + c) + a : area
  item.mergeAreaDetail = area + detail
  return item
}
